export default __webpack_public_path__ + "static/media/increase.8f809245.svg";